<template>
    <div class="col-12 pl-0 pr-0">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
        </div>
        <div v-else>
            <div class="card pb-3" >
                <div class="d-flex ml-2 mr-2 p-2">
                    <img src="../../assets/Search.svg" alt="search">
                    <input type="text" placeholder="Search Candidates with in the results" v-model="searchText" class="border-0 black60 proximanova fontsize16 pl-2 searchCandidate" name="" id="">
                </div>
                <div class="horizontalline"></div>
                <div class="jobslistverticalscroll" id="jobslistdiv" @scroll="handleScroll">
                <div v-for="(candidate, index) in filteredList" :key="index">
                    <div class="d-flex bordertop borderbottom p-2" :class="{'borderleftblue' :candidateSelected===candidate.profileId}">
                        <div class="d-flex flex-column col-12 pl-0 ml-2">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex">
                                <div class="d-flex">
                                    <div class=" mr-2 text-center">
                                        <img v-if="candidate.profilePictureLink" :src="candidate.profilePictureLink" @error="candidate.profilePictureLink = null" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle loadingBgImg" alt="profilepic">
                                        <div v-else id="profImage" class=" text-center pointer rounded-circle white" :class="candidate.firstName.charAt(0)">
                                            <p class="white fontsize16 defmargintop text-uppercase">{{candidate.firstName.charAt(0)}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column mt-1">
                                    <span class="fontsizemd black proximanova stylebold pointer applicantName" @click="selectApplicant(index, candidate)">{{candidate.firstName}} {{candidate.lastName}}</span>
                                    <span class="fontsize12 black60 proximanova text-capitalize">{{candidate.designation.roleName}}, {{candidate.companyDetails.companyName}} <span v-if="candidate.country && candidate.country.countryName">, {{candidate.country.countryName}}</span></span>
                                    <!-- <span class="fontsize12 black60  proximanova">{{ candidate.applicantCreationDate | moment("MMM Do YYYY, h:mm a") }}</span> -->
                                </div>
                            </div>
                            <div class="justify-content-end" v-if="currentRoute !== 'findResumes'">
                                <!-- <span class="fontsize10 backgroundcolor3 borderradius10 proximanova white p-1 pl-2 pr-2 mr-1" v-if="candidate.newApplication && candidate.recruiterViewFlagValue!='Y'">New</span> -->
                                <img src="../../assets/JobDisqualified.svg" class="img-fluid mt-1" alt="disqualified" v-if="candidate.status==='Declined'">
                                <img src="../../assets/JobSelected.svg" class="img-fluid mt-1" alt="selected" v-if="candidate.status==='Accepted'">
                            </div>
                        </div>
                        <div class="horizontalline mt-2 mb-1"></div>
                        <div class="d-lg-flex d-md-flex justify-content-between candidatevideosec">
                            <div class="d-flex pointer" @click="NavToUserTab('videoresume')">
                                <img src="../../assets/VideoProfile.svg" width="25px" class="img-fluid" alt="video">
                                <span class="fontsize12 black proximanova my-auto ml-1 text-nowrap">Video Resume</span>
                            </div>
                            <div class="d-flex pointer" @click="NavToUserTab('videoprofile')">
                                <img src="../../assets/JobVideoProfile.svg" class="img-fluid" alt="video">
                                <span class="fontsize12 black proximanova my-auto ml-1 text-nowrap">Video Profile</span>
                            </div>
                            <div class="d-flex pointer col-3" >
                                <!-- <img src="../../assets/JobTextResume.svg" class="img-fluid" alt="resume">
                                <span class="fontsize12 black proximanova my-auto ml-1 text-nowrap">Text Resume</span> -->
                            </div>
                        </div>
                        <div class="horizontalline mt-1 mb-1"></div>
                        <div v-if="candidate.userKnowledge.length > 0" class="d-flex flex-wrap" >
                            <div v-for="(skill, index) in candidate.userKnowledge" :key="index" >
                                <span v-if="index < 2 " class="pl-3 pr-3 pt-1 mr-2 black60 fontsize12 backgroundcolor12 pb-1 borderadius12 proximanova d-flex mt-1">
                                    {{skill.knowledgeDetails.knowledgeIn}}
                                </span>
                            </div>
                            <span class="fontsize12 black60 proximanova mt-2">More...</span>
                        </div>
                        <div v-else class="text-center">
                            <span class="fontsize12 black60 proximanova mt-2">No skills set available</span>
                        </div>
                        </div>
                    </div>
                    <div class="borderbottomjob"></div>
                </div>
                <div class="col-12 pb-4 mb-4" v-if="candidatesloadmoreLoader">
                    <img src="../../assets/loading_gif1.gif" class="pageloader pageloader1" alt="loading">
                </div>
                </div>
            </div>
        </div>
        <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
    </div>
</template>
<script>
import { bus } from "@/main.js";
import httpuserprofile from "@/js/http-userprofile.js";
import httppostajob from "@/js/http-postjob.js"
import httpbusiness from "@/js/http-business.js"
import $ from 'jquery'
import router from '../../router';
import httpjob from "@/js/http-postjob.js"
import APIErrorModal from '../../components/APIerrorpopup.vue'
import sessionUtils from "@/js/session-util.js";
export default {
    components:{
      APIErrorModal
    },
    data(){
        return{
            displayAPIerrorModal : false,
            pageloader : true,
            companyProfileId : null,
            candidatesList : [],
            instanceCandidatesList : [],
            searchText : "",
            candidateSelected : null,
            designationText : "",
            locationText : "",
            limit : 10,
            offset : 0,
            isScrolled : false,
            candidatesloadmoreLoader : true,
            //selected job details
            currentRoute : null,
            jobId : null,
            jobrequestStatus : '',
            displayToastOnce : false
        }
    },
    created(){
        window.addEventListener('scroll', this.handlesmScroll);
    },
    mounted() {
        this.companyProfileId = sessionUtils.getCompanyProfileId()
        this.currentRoute = this.$router.currentRoute.name;
        if(this.currentRoute == 'findResumes'){
            console.log("into get all aplicants list", this.currentRoute)
            this.getAllApplicantsList()
        }else{
            console.log("into find resumes list")
            this.jobId = sessionUtils.getSelectedJobId();
            this.fetchRequestedResumesBasedOnJob()
        }
        bus.$on("getFilterIndividualResumes", data => {
          console.log("filter data in list component : ", data)
          if(!this.pageloader){
          this.offset = 0;
          this.candidatesList = [];
          this.instanceCandidatesList = [];
          this.pageloader = true;
          this.designationText = data.jobText;
          this.locationText = data.locationSearchtext;
          this.displayToastOnce = false;
          this.getAllApplicantsList()
          }
        });
        bus.$on("getResumesByStatus", data => {
            this.pageloader = true;
            this.offset = 0;
            this.candidatesList = [];
            this.instanceCandidatesList = [];
            this.pageloader = true;
            this.jobrequestStatus = data;
            if(data == 'Total') {
                this.jobrequestStatus = '';
            }
            this.candidatesList = []
            this.fetchRequestedResumesBasedOnJob()
        })
    },
    computed:{
        filteredList(){
            return this.candidatesList.filter(resume => {
                let fullname = resume.firstName + ' ' + resume.lastName
                return fullname.toLowerCase().includes(this.searchText.toLowerCase())
            });
        },
    },
    methods : {
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        fetchRequestedResumesBasedOnJob() {
            httpjob.get('/postjob/getResumesListByJobIdAndStatus?jobId='+this.jobId+'&status='+this.jobrequestStatus+'&limitCounter='+this.limit+'&offset='+this.offset)
            .then((response) => {
                this.pageloader = false;
                console.log("resumeslist : ", response)
                this.instanceCandidatesList = response.data;
                this.candidatesloadmoreLoader = false;
                this.isScrolled = false;
                if(this.instanceCandidatesList && this.instanceCandidatesList.length > 0){
                    for(var i =0; i< this.instanceCandidatesList.length; i++) {
                        this.candidatesList.push(this.instanceCandidatesList[i])
                    }
                }
                if(this.candidatesList.length > 0 && this.offset == 0 && screen.width > 900){
                    this.displayDefaultUserInfo()
                }
                if(this.candidatesList && this.candidatesList.length < 1 && this.offset == 0){
                    bus.$emit('whenJobDontHaveApplicants', true)
                }
                console.log("applications list : ", this.candidatesList)
            }).catch((e) => {
                this.pageloader = false;
                this.candidatesloadmoreLoader = false;
                console.log(e.response)
                if(this.candidatesList.length < 1 && this.offset == 0){
                    bus.$emit('whenJobDontHaveApplicants', true)
                }
            })
        },
        //this will invoke after component is mounted get applicants list based on jobId
        getAllApplicantsList(){
            httpjob.get('/postjob/getResumesList?designation='+this.designationText+'&location='+this.locationText+'&limitCounter='+this.limit+'&offset='+this.offset)
            .then((response) => {
                this.pageloader = false;
                console.log("resumeslist : ", response)
                this.instanceCandidatesList = response.data;
                this.candidatesloadmoreLoader = false;
                this.isScrolled = false;
                if(this.instanceCandidatesList && this.instanceCandidatesList.length > 0){
                    for(var i =0; i< this.instanceCandidatesList.length; i++) {
                        this.candidatesList.push(this.instanceCandidatesList[i])
                    }
                }
                if(this.candidatesList.length > 0 && this.offset == 0 && screen.width > 900){
                    this.displayDefaultUserInfo()
                }
                if(this.candidatesList && this.candidatesList.length < 1){
                    console.log("into bus user resumes list")
                    bus.$emit('whenJobDontHaveApplicants', true)
                }
                console.log("applications list : ", this.candidatesList)
            }).catch((e) => {
                this.pageloader = false;
                this.candidatesloadmoreLoader = false;
                console.log(e.response)
                if(this.candidatesList && this.candidatesList.length < 1){
                    bus.$emit('whenJobDontHaveApplicants', true)
                }
            })
        },
        displayDefaultUserInfo(){
            console.log("clicked")
            var candidates = document.getElementsByClassName('applicantName')
            console.log(candidates)
            setTimeout(function() {
                candidates[0].click()
            },2000);
        },
        //this will invoke after click on candidate name to select the card and display selected user details in details component
        selectApplicant(index, candidate){
            this.candidateSelected = candidate.profileId;
            let obj = {
                userId : candidate.userId
            }
            this.$session.set("selectedResumeUserId", candidate.userId);
            // bus.$emit("sendDataToSelectedResumeTab", obj)
            bus.$emit('userResumeSelection', obj)
            if(screen.width < 900) {
                console.log("check1", screen.width)
                if(this.currentRoute == 'findResumes'){
                    router.push({
                        name : 'userresume_details'
                    })
                }else{
                    router.push({
                        name : 'requested_resume_details'
                    })
                }
            }
        },
        //this will invoke after click on video resume/ video profile/ text resume
        // it will open the candidate tab directly
        NavToUserTab(tabName){
            bus.$emit('openUserDetailsTab', tabName)
        },
        NavToCandidateDetails() {
            if(screen.width < 900) {
                router.push({
                    name : 'userresume_details'
                })
            }
        },
        //this will invoke after scrolling down to get more records
        handleScroll () {   
            var vm = this;
            var myDiv = document.getElementById('jobslistdiv')
           // if(screen.width > 800) {
            if(!this.isScrolled){        
                // console.log(myDiv.offsetHeight + myDiv.scrollTop)
                // console.log(myDiv.scrollHeight)
                // if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown) { 
                if (myDiv.offsetHeight + myDiv.scrollTop + 1 >= myDiv.scrollHeight) {
                    if(this.instanceCandidatesList.length >= 9){
                        this.isScrolled = true;    
                        this.offset = this.offset+1; 
                        this.candidatesloadmoreLoader = true;
                        if(this.currentRoute == 'findResumes'){
                            this.getAllApplicantsList()
                        }else{
                            this.fetchRequestedResumesBasedOnJob()
                        }
                    }else{
                        if(!this.pageloader && !this.displayToastOnce){
                            this.displayToastOnce = true;
                            vm.$toast.info("No More User resumes are available")
                        }
                    }                  
                }        
            //}    
            }
        },
        handlesmScroll(){
            var vm = this;
            if(screen.width < 800) {  
                if(!this.isScrolled){               
                    if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight)) { 
                        if(this.instanceCandidatesList.length >= 9){
                            this.isScrolled = true;    
                            this.offset = this.offset+1; 
                            this.candidatesloadmoreLoader = true;
                            if(this.currentRoute == 'findResumes'){
                                this.getAllApplicantsList()
                            }else{
                                this.fetchRequestedResumesBasedOnJob()
                            }
                        }else{
                            if(!this.pageloader && !this.displayToastOnce){
                                this.displayToastOnce = true;
                                vm.$toast.info("No More User resumes are available")
                            }
                        }              
                    }        
                }   
            }
        },
    },
    beforeDestroy(){
        bus.$off('userResumeSelection')
        bus.$off('openUserDetailsTab')
        bus.$off('getFilterIndividualResumes')
        bus.$off('whenJobDontHaveApplicants')
        window.removeEventListener('scroll', this.handlesmScroll);
    },
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.searchCandidate{
    width: 80%;
}
.borderradiushalf{
    padding: 2px;
}
.searchCandidate:focus{
    outline: none;
}
.pageloader{
    width: 10% !important;
}
.pageloader1{
    margin-top: 5% !important;
}
#profImage{
    width: 45px;
    height: 45px;
    border:1px solid #ced4da;
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 70px !important;
  width: 150px !important;
  padding: 5px 10px 5px 10px !important;
  transform: translate3d(-25%, 10px, 10px) !important;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
#deleteExpModal{
  margin-top: 15%;
  padding-right: 0px !important;
}
/* filter dropdown */
.dropdown-menu{
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  top: 0;
  right: 0;
  z-index: 3;
  left: unset !important;
  margin-top: 75px;   
  border-radius: 10px  !important;
}
.dropdownmenu1{
    display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  left: 0 !important;
  margin-top: 35px;   
  border-radius: 10px  !important;
}
.closebtnmouseover {
    border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.input-group-append{
  margin-left: 0  !important;
}
.searchtext{
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
.form-control:focus{
  outline: none !important;
  box-shadow: none !important;   
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
.input-group-append{
  margin-left: 0  !important;
}
.imgborder1 {
  padding: 11px 15px 11px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.list-group-item{
  padding: .25rem 0.25rem;
  border: none;
  cursor: pointer;
}
@media screen and (max-width: 1050px) and (min-width : 1020px) {
  .candidatevideosec{
      display: flex !important;
      flex-direction: column !important;
  }
}
@media screen and (min-width: 770px) {
    .jobslistverticalscroll{
        height: 100vh !important;
        overflow: auto;
    }
    /* .jobslistverticalscroll::-webkit-scrollbar {
        display: none;
    } */
}
</style>